// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listbox {
  width: 100%;
  height:100%;
}

.list{
    min-width:250px;
    max-width:400px;
}
.form-field{
    width:100%;
}
.detail-wrapper{
    padding:15px;
    overflow:hidden;
}
.detail-fields{
    height:100%;
    overflow:auto;
}
.wrapper{
    height:100%;
}
.listbox-wrapper{
    overflow:hidden;
    height:100%;
    border:1px solid black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/listdetail/listdetail.control.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":[".listbox {\n  width: 100%;\n  height:100%;\n}\n\n.list{\n    min-width:250px;\n    max-width:400px;\n}\n.form-field{\n    width:100%;\n}\n.detail-wrapper{\n    padding:15px;\n    overflow:hidden;\n}\n.detail-fields{\n    height:100%;\n    overflow:auto;\n}\n.wrapper{\n    height:100%;\n}\n.listbox-wrapper{\n    overflow:hidden;\n    height:100%;\n    border:1px solid black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
